import {
  Dialog,
  ListItemIcon,
  ListItemText,
  MenuItem,
} from "@material-ui/core";

import { ClassNameMap } from "@material-ui/styles";
import React, { useState } from "react";
import { useTranslate } from "react-admin";
import {
  ApproveOrDenyTenantRegistrationDto,
  TenantRegistrationApiFactory,
  TenantRegistrationDto,
  TenantRegistrationStatus,
} from "../../../common/data/service-proxies";
import { useAxiosInstance } from "../../../common/hooks/useAxiosInstance";
import { HookFormCreateView } from "../../common/form/hook-form/HookFormCreateView";
import { ApproveRegistrationForm } from "./ApproveRegistrationForm";

interface Props {
  label: string;
  icon: JSX.Element;
  record: TenantRegistrationDto;
  classes: ClassNameMap<"approve">;
  resource: string;
  onClick?: (event: React.MouseEvent) => void;
  onSuccess?: () => void;
}

const getRecord = (
  record: TenantRegistrationDto
): ApproveOrDenyTenantRegistrationDto => {
  return {
    id: record.id,
    status: TenantRegistrationStatus.Active,
    tenantInfo: {
      name: record.name,
      adminName: record.adminName,
      adminEmailAddress: record.adminEmailAddress,
      customerContactEmail: record.customerContactEmail ?? "",
      customerContactName: record.customerContactName ?? "",
      customerContactPhone: record.customerContactPhone ?? "",
      hasOwnElds: record.hasOwnElds,
      domainName: record.domainName,
      parentTenantId: record.creatorTenantId,
      dbServer: "",
      appUrl: "",
      webApiUrl: "",
      dbName: "",
    },
  };
};

export const ApproveRegistrationMenuItem = ({
  label,
  record,
  resource,
  onClick,
  icon,
  classes,
  onSuccess,
  ...rest
}: Props) => {
  const [isOpen, setOpen] = useState(false);
  const translate = useTranslate();
  const axios = useAxiosInstance();

  const handleDialogClose = () => {
    setOpen(false);
  };

  return (
    <>
      <MenuItem
        {...rest}
        className="actions-menu-item"
        onClick={(e) => {
          setOpen(true);
          if (typeof onClick === "function") {
            onClick(e);
          }
        }}>
        <ListItemIcon className={classes.approve}>{icon}</ListItemIcon>
        <ListItemText>{translate(label, { _: label })}</ListItemText>
      </MenuItem>
      <Dialog
        open={isOpen}
        onClose={handleDialogClose}
        fullWidth
        scroll="paper">
        <HookFormCreateView
          onSuccess={() => {
            handleDialogClose();
            if (onSuccess) onSuccess();
          }}
          variant="outlined"
          margin="dense"
          className="form-create-edit-drawer"
          record={getRecord(record)}
          resource="master-tenant-registrations"
          title={translate(
            "resources.master-tenant-registrations.title.approve"
          )}
          popup
          actions={false}
          createMethodOverride={(data) => {
            if (!axios) {
              return Promise.reject("Axios was undefined");
            }

            return TenantRegistrationApiFactory(
              undefined,
              axios.defaults.baseURL,
              axios
            ).apiAppTenantregistrationApproveordenypendingrequestPost(data);
          }}>
          <ApproveRegistrationForm />
        </HookFormCreateView>
      </Dialog>
    </>
  );
};
